
import './styles.css'


import { ArrowDown2 } from 'iconsax-react';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


import CarouselSevices, { servicesTravel } from '../../share/components/CarouselServices/CarouselSevices'

import { Link } from 'react-router-dom';

import Find from '../../share/components/Find/Find';
import useTransport from '../../../viewModels/transport/TransportC'


import formImg from '../../../assets/pictures/person-traslado.png'
import taxi from '../../../assets/icons/taxi-background.png'

import viaja from '../../../assets/images/viaja.png'
import Check from '../../../assets/images/Check.png'


import IconWhatsapp from '../../../assets/iconsSVG/IconWhatsapp.svg'

import { iconList } from '../../share/components/iconSVG';

import SvgIcon from '../../share/components/iconSVG';
import AnyQuestions from '../../home/components/anyQuestion';

const Transport = () => {
  const {
    adult,
    baby,
    setTypeT,
    typeT,
    ciudadDropdown,
    setCiudadDropdown,
    aeropuertoDropdown,
    setAeropuertoDropdown,
    formValidate,
    passengersCal,
    findCity,
    cityList,
    citySelected,
    setcitySelected,
    findOrigin,
    originList,
    originSelected,
    setOriginSelected,
    findDestiny,
    destinyList,
    destinySelected,
    setDestinySelected,
    destinyDropdown,
    setDestinyDropdown,
    findServices,
    selectedDate,
    handleDateChange
  } = useTransport()



  return (
    <div>

      <Find />
      <CarouselSevices current={servicesTravel[3].title} />



      <section className='contain-buscador-transport'>
        <div className='layout-one-t'>
          <div className='check-title'>
            <img src={Check} alt="" />
            <h4>Traslados hotel - aeropuerto aeropuerto - hotel</h4>
          </div>
          <div className='contain-form'>
            <form action="" onSubmit={e => findServices(e)}>
              <div className="campo-t">
                <label htmlFor="">Tipo de Traslado:</label>
                <select className='input-ca' name="" id="" onChange={(e) => (setTypeT(e.target.value))}>
                  <option value="">Selecciona Tipo de traslado</option>
                  <option value="ONLY_TO_AIRPORT">Ida Aeropuerto</option>
                  <option value="ONLY_FROM_AIRPORT">Ida Hotel</option>
                  <option value="ROUND_TRIP">Ida y Vuelta</option>
                </select>
              </div>
              <div className="campo-t">
                <label htmlFor="">Ciudad:</label>
                <div className="input-ca" onClick={() => setCiudadDropdown(!ciudadDropdown)}>

                  <p>{citySelected !== '' ? citySelected.name : 'Selecciona Ciudad'}</p> <span><ArrowDown2 size="20" color="rgb(78, 78, 78)" /></span>

                </div>

                {
                  ciudadDropdown === true &&
                  <div className='dropdown-ciudad shadow' >
                    <div style={{ background: "white", borderRadius: "15px", width: "100%" }}>
                      <input className='input-dropdown' onChange={(e) => findCity(e.target.value)} type="text" placeholder='Ciudad' />

                    </div>
                    <ul className='city-result'>
                      {cityList &&
                        cityList.map((item) => {
                          return (
                            <li onClick={() => {
                              setcitySelected(item)
                              setCiudadDropdown(!ciudadDropdown)
                            }} key={item.id}>
                              {item.name}
                            </li>
                          )
                        })}
                    </ul>
                  </div>
                }


              </div>
              <div className="campo-t">
                <label htmlFor="">Origen:</label>
                <div className="input-ca" onClick={() => {
                  setAeropuertoDropdown(!aeropuertoDropdown)
                  findOrigin()
                }}>
                  <p>{originSelected !== '' ? originSelected.name : 'Selecciona Aeropuerto'}</p> <span><ArrowDown2 size="20" color="rgb(78, 78, 78)" /></span>
                </div>
                {
                  aeropuertoDropdown === true &&
                  <div className='dropdown-ciudad shadow' >
                    <div style={{ background: "white", borderRadius: "15px", width: "100%" }}>
                      <input className='input-dropdown' type="text" placeholder='Aeropuerto' />
                    </div>
                    <ul className='city-result'>
                      {originList &&
                        originList.map((item) => {
                          return (
                            <li onClick={() => {
                              setOriginSelected(item)
                              setAeropuertoDropdown(!aeropuertoDropdown)
                            }} key={item.id}>
                              {item.name}
                            </li>
                          )
                        })}
                    </ul>
                  </div>
                }
              </div>
              <div className="campo-t">
                <label htmlFor="">Destino:</label>
                <div className="input-ca" onClick={() => {
                  setDestinyDropdown(!destinyDropdown)
                  findDestiny()
                }}>
                  <p>{destinySelected !== '' ? destinySelected.name : 'Selecciona Destino'}</p> <span><ArrowDown2 size="20" color="rgb(78, 78, 78)" /></span>
                </div>
                {
                  destinyDropdown === true &&
                  <div className='dropdown-ciudad shadow' >
                    <div style={{ background: "white", borderRadius: "15px", width: "100%" }}>
                      <input className='input-dropdown' type="text" placeholder='Aeropuerto' />
                    </div>
                    <ul className='city-result'>
                      {destinyList &&
                        destinyList.map((item) => {
                          return (
                            <li onClick={() => {
                              setDestinySelected(item)
                              setDestinyDropdown(!destinyDropdown)
                            }} key={item.id}>
                              {item.name}
                            </li>
                          )
                        })}
                    </ul>
                  </div>
                }
              </div>

            
                 
                  

                  <div className='campo-t'>
                    <label htmlFor="">Selecciona Fecha y Hora:</label>

                    <DatePicker
                      selected={selectedDate}
                      onChange={handleDateChange}
                      showTimeSelect
                      dateFormat="yyyy-MM-dd-HH-mm"
                      className='input-ca'
                    />


                  </div>
              


              <div className="campo-three">
                <div>
                  <label htmlFor="">Adultos <br /> <span>+18</span></label>
                  <div className='btn-passengers'>
                    <button onClick={(e) => passengersCal(e, "ad", 1)}>
                      +
                    </button>
                    <span>{adult}</span>
                    <button onClick={(e) => passengersCal(e, "ad", -1)}>
                      -
                    </button>
                  </div>
                </div>

                <div>
                  <label htmlFor="">Bebes <br></br> <span>-1 Año</span></label>
                  <div className='btn-passengers'>
                    <button onClick={(e) => passengersCal(e, "bb", 1)}>
                      +
                    </button>
                    <span>{baby}</span>
                    <button onClick={(e) => passengersCal(e, "bb", -1)}>
                      -
                    </button>
                  </div>
                </div>
              </div>
              {
                formValidate === '' ?
                  ''
                  :
                  <div className='error-form'>
                    <p>{formValidate}</p>
                  </div>
              }

              <div className='contain-btn-t'>
                <button >Buscar Traslado</button>
              </div>
            </form>
            <img className='img-viaja' src={viaja} alt="" />
          </div>

        </div>
        <div className='layout-two-t'>
          <img className='fd-img' src={taxi} alt="" />
          <img className='up-img' src={formImg} alt="" />
        </div>
      </section>
      <section className='contain-contact-t'>
        <Link to={'https://wa.link/uq1q0p'}>
          <div>
            <SvgIcon color={'#004274'} size={150} name={iconList.IconWhatsapp} />
          </div>
          <div className='text-contact-t'>
            <h3>
              ¿Tienes dudas? ¡Escribenos!
            </h3>
            <p>
              Habla con un asesor vía whatsapp, cuentanos a que lugares quieres ir, que dudas tienes, que servicios necesitas? Estamos para que viajes con todas las comodidades
            </p>
          </div>
        </Link>

      </section>

      <AnyQuestions title={"¿Tienes alguna duda?"}/>

    </div>
  )
}

export default Transport